<div class="w-100">
    <div class="login mt-0 box-bg form-padding">
        <!-- <ngx-loading [show]="loading"></ngx-loading> -->
        <div class="login-title primary-header">Forgot your password?</div>
        <div class="floating-form" [formGroup]="forgotForm">
            <div class="d-flex justify-content-center  align-items-center w-100 h-100">
                <div class="loaderSvg d-flex align-items-center justify-content-center">
                </div>
            </div>
            <div class="d-flex flex-column ">

                <mat-form-field class="field">
                    <mat-label>Organisation</mat-label>
                    <input matInput oninput="this.value = this.value.toUpperCase()" placeholder="Organisation"
                        formControlName="domain">
                    <ng-container *ngIf="forgotSubmitted && forgotFormValues['domain'].errors">
                        <mat-error *ngIf="forgotFormValues['domain'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Organisation is required
                        </mat-error>
                        <mat-error *ngIf="forgotFormValues['domain'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and
                            end
                        </mat-error>
                    </ng-container>
                </mat-form-field>
                <div class="d-flex">
                    <div class="flex1 mr-2">

                        <mat-form-field>
                            <mat-select [disableOptionCentering]="true" [(ngModel)]="searchSelection"
                                (selectionChange)="searchDropdownChange($event)" [ngModelOptions]="{standalone: true}">
                                <mat-option value="employeeId">Employee Id</mat-option>
                                <mat-option value="userName">Username</mat-option>
                                <mat-option value="email">Email</mat-option>
                                <mat-option value="number">Phone Number</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>


                    <div *ngIf="searchSelection=='number'" class="flex2 iti-pb">
                        <ngx-intl-tel-input [cssClass]="'phoneNumber'" [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true" [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                            [phoneValidation]="false" [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National" formControlName="number">
                        </ngx-intl-tel-input>
                        <ng-container
                            *ngIf="forgotSubmitted && (forgotFormValues['number'].errors || !forgotForm.value.number)">
                            <mat-error
                                *ngIf="forgotFormValues['number'].errors?.['required'] || !forgotForm.value.number">
                                <em class="fas fa-exclamation-circle mr-2"></em>Phone number is required
                            </mat-error>
                        </ng-container>
                    </div>

                    <div *ngIf="searchSelection=='employeeId'" class="flex2">
                        <mat-form-field class="field">
                            <input matInput formControlName="empId">
                            <ng-container *ngIf="forgotSubmitted && forgotFormValues['empId'].errors">
                                <mat-error *ngIf="forgotFormValues['empId'].errors?.['required']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>EmployeeId is required
                                </mat-error>
                                <mat-error *ngIf="forgotFormValues['empId'].errors?.['pattern']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from
                                    start and end
                                </mat-error>
                            </ng-container>
                        </mat-form-field>
                    </div>

                    <div *ngIf="searchSelection=='email'" class="flex2">
                        <mat-form-field class="field">
                            <input matInput formControlName="email">
                            <ng-container *ngIf="forgotSubmitted && forgotFormValues['email'].errors">
                                <mat-error *ngIf="forgotFormValues['email'].errors?.['required']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Email is required
                                </mat-error>
                                <mat-error *ngIf="forgotFormValues['email'].errors?.['pattern']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Enter a valid email address
                                </mat-error>
                            </ng-container>
                        </mat-form-field>
                    </div>

                    <div *ngIf="searchSelection=='userName'" class="flex2">
                        <mat-form-field class="field">
                            <input matInput formControlName="userName">
                            <ng-container *ngIf="forgotSubmitted && forgotFormValues['userName'].errors">
                                <mat-error *ngIf="forgotFormValues['userName'].errors?.['required']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Username is required
                                </mat-error>
                                <mat-error *ngIf="forgotFormValues['userName'].errors?.['pattern']" class="-t-40">
                                    <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from
                                    start and end
                                </mat-error>
                            </ng-container>
                        </mat-form-field>
                    </div>

                </div>



                <div class="d-flex justify-content-center">
                    <div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
                            class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
                </div>

                <div class="btn-basket">
                    <button mat-raised-button class="" color="primary" (click)="resetPassword()">
                        Submit
                    </button>
                    <button mat-raised-button class="" color="primary" (click)="loadLoginForm()">
                        Cancel
                    </button>
                </div>
            </div>

        </div>

        <div class="d-flex justify-content-center">
            <div class="linkStyle mt-2 ft-12">Already Registered? <label class="cursor text-underline ft-12"
                    (click)="loadLoginForm()"><u>Login
                        Here</u></label> </div>
        </div>
    </div>
</div>